import { ElectronicHookSwitchAttribute } from '../enums/electronic-hook-switch-attribute.enum';
export var excludeEHSFilterQuery = function (ids) {
    var query = '';
    var idsLength = ids.length;
    for (var _i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
        var id = ids_1[_i];
        if (idsLength === 1 || !--idsLength) {
            query += "groupId eq " + id;
        }
        else {
            query += "groupId eq " + id + " or ";
        }
    }
    query = "(" + query + ")";
    query += " and attributes/all(a: a ne '" + ElectronicHookSwitchAttribute.Key + "|" + ElectronicHookSwitchAttribute.Value + "')";
    return query || '';
};
